export default __webpack_public_path__ + "static/media/pic6.1d774d82.png";